import { getOr, map } from 'lodash/fp';

export const facetMatchWith = (facetName: string, overrider: any) => (facet: any) => {
  const { name } = facet;
  return name === facetName ? overrider(facet) : facet;
};

export const matchLanguageDictionary = (dictionary: any) => (facet: any) => {
  const { options = [] } = facet;
  return {
    ...facet,
    options: map((option: any) => {
      const { value } = option;
      return {
        ...option,
        label: getOr(value, value, dictionary),
      };
    }, options),
  };
};
